import { render } from "./works.vue?vue&type=template&id=4ceda91e&scoped=true"
const script = {}

import "./works.vue?vue&type=style&index=0&id=4ceda91e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ceda91e"]])

export default __exports__